import cookie from '../cookie'

const isError = error => {
  try {
    if (error instanceof Error) return true
    if (error.constructor.toString().match(/Error/)) return true // cypress errors
    return false
  } catch (error) {
    return false
  }
}

const triggerPageActionEvent = eventProps => {
  if (
    typeof window.newrelic !== 'undefined' &&
    typeof window.newrelic.addPageAction === 'function'
  ) {
    window.newrelic.addPageAction('sso-ui', { ...eventProps })
  }
}

export const newRelicTriggerSuccessEvent = page => triggerPageActionEvent({ type: 'success', page })

export const newRelicTriggerErrorEvent = (page, originalError) => {
  const error = isError(originalError) ? originalError.message : originalError
  triggerPageActionEvent({ type: 'error', page, error })
}

export const setupNewRelic = () => {
  if (
    typeof window.newrelic !== 'undefined' &&
    typeof window.newrelic.setCustomAttribute === 'function'
  ) {
    window.newrelic.setCustomAttribute('sessionId', cookie.getCookie('jl_session_id'))
  }
}
